import styled from 'styled-components';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../theme';
import { RadioState, Status } from './types';
import { fontSmoothing } from '../../../mixins';

export const RadioInput = styled.input<{ variant: RadioState }>`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  border-radius: 50%;

  &:before {
    content: '';
    border-radius: 50%;
  }

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'RadioButton', 'variant')
    )};
`;

export const RadioLabel = styled.label<{ labelVariant: Status }>`
  display: inline-flex;
  align-items: center;
  ${fontSmoothing};

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'RadioButton', 'labelVariant')
    )};
`;
